document.addEventListener("DOMContentLoaded", (event) => {
    let descContainerElements = document.querySelectorAll('.key-features__text-desc');
    let PdpHero = document.querySelectorAll('.desciption-mobile .desciption');
    let whatsIncluded = document.querySelectorAll('.whats-included__text-desc');

    function dropdownText(block) {
        if (block) {
            block.forEach((descContainerElement) => {
                const readMoreElement = descContainerElement.nextElementSibling;
                const descRightElement = descContainerElement.querySelector('.key-features__text-desc_right>p');
                const descRightHasText = (descRightElement && descRightElement.innerHTML);
                const divHeight = descContainerElement.scrollHeight

                function toggleTextVisibility() {
                    if (descContainerElement.classList.contains('show')) {
                        descContainerElement.classList.remove('show');
                        readMoreElement.innerText = 'Read more';
                        descContainerElement.style.height = '';
                    } else {
                        descContainerElement.classList.add('show');
                       /* descContainerElement.style.height = divHeight + 'px';*/
                        readMoreElement.innerText = 'HIDE DETAILS';
                    }
                }

                readMoreElement.addEventListener('click', toggleTextVisibility);

                function checkTextSize() {
                    if ( window.innerWidth < 1024
                        && (descContainerElement.scrollHeight > 72
                            || descRightHasText)) {
                        readMoreElement.style.display = 'block';
                    } else {
                        readMoreElement.style.display = 'none';
                    }
                }
                checkTextSize();

                window.addEventListener('resize', checkTextSize);
            });
        }
    }

    dropdownText(descContainerElements)
    dropdownText(whatsIncluded)
    dropdownText(PdpHero)

    let sliderElement = document.querySelector('.key-features.full-width');

    if (sliderElement) {
        let containerDiv = document.createElement('div');
        containerDiv.className = 'container-btn';

        let buttons = sliderElement.querySelectorAll('.key-features__slider .flickity-button');

        buttons.forEach(function(button) {
            containerDiv.appendChild(button);
        });

        sliderElement.appendChild(containerDiv);
    }

    document.querySelectorAll('.pdp-video').forEach((videoBlock) => {
        const hammertime = new Hammer(videoBlock);
        hammertime.on('tap', (ev) => {
            ev.preventDefault();
            const videoElement = videoBlock.querySelector('video');
            const playPromise = videoElement.play();
            switch (ev.type) {
                case 'tap': {
                    const videoElement = videoBlock.querySelector('video');
                    if (videoElement) {
                        if (videoBlock.classList.contains('play')) {
                            const videoElement = videoBlock.querySelector('video');
                            videoElement.pause();
                            videoElement.removeAttribute('controls');
                            videoBlock.classList.remove('play');
                        } else {
                            playPromise.then(_ => {
                                const videoElement = videoBlock.querySelector('video');
                                videoElement.setAttribute('controls', 'controls');
                                videoBlock.classList.add('play');

                            })
                                .catch(error => console.log(error));
                        }
                    }
                    break;
                }
                /*case 'panup' || 'pandown': {
                    console.log('panup or pandown')
                    const videoElement = videoBlock.querySelector('video');
                    const videoBounding = videoElement.getBoundingClientRect();
                    const isVideoVisible = !!(videoBounding.top < window.innerHeight && videoBounding.bottom >= 0);
                    if (videoBlock.classList.contains('play') && !isVideoVisible) {
                        videoElement.pause();
                        videoElement.removeAttribute('controls');
                        videoBlock.classList.remove('play');
                        if (navigationButtons) {
                            navigationButtons.forEach((button) => {
                                button.style.display = 'flex';
                            })
                        }
                    }
                }*/
            }
        })
        /* hammertime.on('tap', (ev) => {
             console.log('Tapped')
             const videoElement = videoBlock.querySelector('video');
             if (videoElement) {
                 if (videoBlock.classList.contains('play')) {
                     console.log('to pause')
                     videoElement.pause();
                     videoElement.removeAttribute('controls');
                     videoBlock.classList.remove('play');
                     if (navigationButtons) {
                         navigationButtons.forEach((button) => {
                             button.style.display = 'flex';
                         })
                     }
                 } else {
                     console.log('to play')
                     videoElement.play();
                     videoElement.setAttribute('controls', 'controls');
                     videoBlock.classList.add('play');
                     if (navigationButtons) {
                         navigationButtons.forEach((button) => {
                             button.style.display = 'none';
                         })
                     }
                 }
             }
         });*/
    });

    document.querySelectorAll('.sub').forEach(function (element) {
        element.addEventListener('click', function () {
            let input = this.parentElement.querySelector('input');
            let count = parseInt(input.value) - 1;
            count = count < 1 ? 1 : count;
            input.value = count;
            input.dispatchEvent(new Event('change'));
            return false;
        });
    });

    document.querySelectorAll('.add').forEach(function (element) {
        element.addEventListener('click', function () {
            let input = this.parentElement.querySelector('input');
            input.value = parseInt(input.value) + 1;
            input.dispatchEvent(new Event('change'));
            return false;
        });
    });

    const moreBtnElem = document.getElementById('more-faqs-btn');
    const tabsWithMoreBtn = (moreBtnElem) ? moreBtnElem.dataset.tabs.split('%%') : [];
    tabsWithMoreBtn.pop();

    function filterFAQ(tag) {
        let accordions = document.querySelectorAll('.faq-pdp__accordion-item_wrap');
        accordions.forEach(function (accordion) {
            accordion.style.display = 'none';
            accordion.removeAttribute('filtered-item');
        });

        let filteredAccordions = document.querySelectorAll('.faq-pdp__accordion-item_wrap[data-tags*="' + tag + '"]');
        filteredAccordions.forEach(function (accordion) {
            accordion.style.display = 'flex';
            accordion.setAttribute('filtered-item', '');
        });

        let tabs = document.querySelectorAll('.faq-pdp__tabs-tab');
        tabs.forEach(function (tab) {
            tab.classList.remove('active');
        });

        let selectedTab = Array.from(tabs).filter(function (tab) {
            return tab.getAttribute('data-tag') === tag;
        })[0];

        selectedTab.classList.add('active');
        const moreBtnWrapper = document.querySelector('.faq-pdp .faq-pdp__more-faqs-wrapper');
        if (tabsWithMoreBtn.includes(selectedTab.dataset.tag)) moreBtnWrapper.classList.add('enabled');
        else moreBtnWrapper.classList.remove('enabled');
    }

    function searchingFAQ() {
        const value = document.querySelector('[data-search]').value.toLowerCase();
        const faqItems = document.querySelectorAll('[filtered-item]');

        faqItems.forEach((faqItem) => {
            const faqItemValues = faqItem.querySelectorAll('p');
            let isAnyMatched = false;
            faqItemValues.forEach((faqItemValue) => {
                if (faqItemValue.innerHTML.toLowerCase().includes(value))  isAnyMatched = true
            })
            if (isAnyMatched) faqItem.style.display = 'flex';
            else faqItem.style.display = 'none';
        })
    }

    function toggleAccordion(element) {
        element.classList.toggle('active');
        let content = element.nextElementSibling;

        if (content.style.maxHeight) {
            content.style.maxHeight = null;
            content.style.marginTop = null;
        } else {
            content.style.maxHeight = '100%';
            content.style.marginTop = 16 + 'px';
        }
    }

    let tabs = document.querySelectorAll('.faq-pdp__tabs-tab');

    tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            let tag = this.getAttribute('data-tag');
            filterFAQ(tag);
            searchingFAQ();
        });

        if (index === 0) {
            tab.classList.add('active');
            filterFAQ(tab.getAttribute('data-tag'));
        }
    });

    let accordionHeaders = document.querySelectorAll('.faq-pdp__accordion-item_wrap-header');

    accordionHeaders.forEach(function (header) {
        header.addEventListener('click', function () {
            toggleAccordion(this);
        });
    });

    const searchInput = document.querySelector("[data-search]");
    if (searchInput) searchInput.addEventListener('input', searchingFAQ);
});